module.exports = __webpack_public_path__ + "static/media/Inscriptions.c2e8424a.svg";